// ReduxHelmet.js
'use strict';
import { connect } from 'react-redux';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import ReduxHelmet from '../component/ReduxHelmet.jsx';

import { DEFAULT_OG_TITLE, BRANDING_NAME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, ownProps) => {
  const { ogTitle: defaultOgTitle, brandingName: defaultBrandingName } =
    ownProps;

  const ogTitle =
    getRemoteConfigData(state, DEFAULT_OG_TITLE) || defaultOgTitle || '';
  const brandingName =
    getRemoteConfigData(state, BRANDING_NAME) || defaultBrandingName || 'SWAG';

  return {
    ogTitle,
    brandingName,
  };
};

export default connect(mapStateToProps)(ReduxHelmet);
